import React from 'react';
import { Link } from 'react-router-dom';
import Navigation from '../components/Navigation.jsx';
import Footer from '../components/Footer.jsx';

function TermsConditions() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-cream-50">
      <Navigation />
      
      {/* Hero Section */}
      <section className="pt-32 pb-16 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <Link to="/" className="inline-flex items-center text-sage-600 hover:text-sage-700 mb-8 transition-colors">
            <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            Back to Home
          </Link>
          
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-light text-sage-800 mb-6 leading-tight">
            Terms and Conditions
          </h1>
          <p className="text-lg text-gray-600 leading-relaxed mb-4">
            Last Updated: January 2025
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="px-4 sm:px-6 lg:px-8 pb-20 bg-white">
        <div className="max-w-4xl mx-auto">
          <div className="prose prose-lg max-w-none">
            <p className="text-lg text-gray-600 leading-relaxed mb-8">
              Welcome to HopefulPaths! These terms and conditions outline the rules and regulations for the use of HopefulPaths Therapy & Coaching's Website.
            </p>
            
            <p className="text-gray-600 leading-relaxed mb-8">
              By accessing this website we assume you accept these terms and conditions. Do not continue to use HopefulPaths if you do not agree to take all of the terms and conditions stated on this page.
            </p>

            <h2 className="text-3xl font-serif font-light text-sage-800 mt-12 mb-6">1. Cookies</h2>
            <p className="text-gray-600 leading-relaxed mb-6">
              The website uses cookies to help personalize your online experience. By accessing HopefulPaths, you agreed to use the required cookies.
            </p>

            <h2 className="text-3xl font-serif font-light text-sage-800 mt-12 mb-6">2. License</h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              Unless otherwise stated, HopefulPaths and/or its licensors own the intellectual property rights for all material on this website. All intellectual property rights are reserved. You may access this from HopefulPaths for your own personal use subjected to restrictions set in these terms and conditions.
            </p>
            
            <p className="text-gray-600 leading-relaxed mb-4">You must not:</p>
            <ul className="list-disc pl-8 space-y-2 text-gray-600 mb-6">
              <li>Republish material from HopefulPaths</li>
              <li>Sell, rent or sub-license material from HopefulPaths</li>
              <li>Reproduce, duplicate or copy material from HopefulPaths</li>
              <li>Redistribute content from HopefulPaths</li>
            </ul>

            <h2 className="text-3xl font-serif font-light text-sage-800 mt-12 mb-6">3. User Comments</h2>
            <p className="text-gray-600 leading-relaxed mb-6">
              Certain parts of this website offer the opportunity for users to post and exchange opinions and information in certain areas of the website. HopefulPaths does not filter, edit, publish or review Comments prior to their presence on the website. Comments do not reflect the views and opinions of HopefulPaths, its agents and/or affiliates. Comments reflect the views and opinions of the person who post their views and opinions.
            </p>
            
            <p className="text-gray-600 leading-relaxed mb-6">
              To the extent permitted by applicable laws, HopefulPaths shall not be liable for the Comments or for any liability, damages or expenses caused and/or suffered as a result of any use of and/or posting of and/or appearance of the Comments on this website.
            </p>
            
            <p className="text-gray-600 leading-relaxed mb-6">
              HopefulPaths reserves the right to monitor all Comments and to remove any Comments which can be considered inappropriate, offensive or causes breach of these Terms and Conditions.
            </p>

            <p className="text-gray-600 leading-relaxed mb-4">You warrant and represent that:</p>
            <ul className="list-disc pl-8 space-y-2 text-gray-600 mb-6">
              <li>You are entitled to post the Comments on our website and have all necessary licenses and consents to do so</li>
              <li>The Comments do not invade any intellectual property right, including without limitation copyright, trademark, or any other proprietary right</li>
              <li>The Comments do not contain any defamatory, libelous, offensive, indecent or otherwise unlawful material which is an invasion of privacy</li>
              <li>The Comments will not be used to solicit or promote business or custom or present commercial activities or unlawful activity</li>
            </ul>

            <p className="text-gray-600 leading-relaxed mb-6">
              You hereby grant HopefulPaths a non-exclusive license to use, reproduce, edit and authorize others to use, reproduce and edit any of your Comments in any and all forms, formats or media.
            </p>

            <h2 className="text-3xl font-serif font-light text-sage-800 mt-12 mb-6">4. Hyperlinking to our Content</h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              The following organizations may link to our Website without prior written approval:
            </p>
            <ul className="list-disc pl-8 space-y-2 text-gray-600 mb-6">
              <li>Government agencies</li>
              <li>Search engines</li>
              <li>News organizations</li>
              <li>Online directory distributors may link to our Website in the same manner as they hyperlink to the Websites of other listed businesses</li>
              <li>System wide Accredited Businesses except soliciting non-profit organizations, charity shopping malls, and charity fundraising groups which may not hyperlink to our Web site</li>
            </ul>

            <p className="text-gray-600 leading-relaxed mb-6">
              These organizations may link to our home page, to publications or to other Website information so long as the link: (a) is not in any way deceptive; (b) does not falsely imply sponsorship, endorsement or approval of the linking party and its products and/or services; and (c) fits within the context of the linking party's site.
            </p>

            <h2 className="text-3xl font-serif font-light text-sage-800 mt-12 mb-6">5. iFrames</h2>
            <p className="text-gray-600 leading-relaxed mb-6">
              Without prior approval and written permission, you may not create frames around our Webpages that alter in any way the visual presentation or appearance of our Website.
            </p>

            <h2 className="text-3xl font-serif font-light text-sage-800 mt-12 mb-6">6. Content Liability</h2>
            <p className="text-gray-600 leading-relaxed mb-6">
              We shall not be hold responsible for any content that appears on your Website. You agree to protect and defend us against all claims that is rising on your Website. No link(s) should appear on any Website that may be interpreted as libelous, obscene or criminal, or which infringes, otherwise violates, or advocates the infringement or other violation of, any third party rights.
            </p>

            <h2 className="text-3xl font-serif font-light text-sage-800 mt-12 mb-6">7. Reservation of Rights</h2>
            <p className="text-gray-600 leading-relaxed mb-6">
              We reserve the right to request that you remove all links or any particular link to our Website. You approve to immediately remove all links to our Website upon request. We also reserve the right to amend these terms and conditions and its linking policy at any time. By continuously linking to our Website, you agree to be bound to and follow these linking terms and conditions.
            </p>

            <h2 className="text-3xl font-serif font-light text-sage-800 mt-12 mb-6">8. Removal of links from our website</h2>
            <p className="text-gray-600 leading-relaxed mb-6">
              If you find any link on our Website that is offensive for any reason, you are free to contact and inform us at any moment. We will consider requests to remove links but we are not obligated to or so or to respond to you directly.
            </p>
            
            <p className="text-gray-600 leading-relaxed mb-6">
              We do not ensure that the information on this website is correct, we do not warrant its completeness or accuracy; nor do we promise to ensure that the website remains available or that the material on the website is kept up to date.
            </p>

            <h2 className="text-3xl font-serif font-light text-sage-800 mt-12 mb-6">9. Disclaimer</h2>
            <p className="text-gray-600 leading-relaxed mb-4">
              To the maximum extent permitted by applicable law, we exclude all representations, warranties, and conditions relating to our website and the use of this website. Nothing in this disclaimer will:
            </p>
            <ul className="list-disc pl-8 space-y-2 text-gray-600 mb-6">
              <li>Limit or exclude our or your liability for death or personal injury</li>
              <li>Limit or exclude our or your liability for fraud or fraudulent misrepresentation</li>
              <li>Limit any of our or your liabilities in any way that is not permitted under applicable law</li>
              <li>Exclude any of our or your liabilities that may not be excluded under applicable law</li>
            </ul>

            <p className="text-gray-600 leading-relaxed mb-6">
              The limitations and prohibitions of liability set in this Section and elsewhere in this disclaimer: (a) are subject to the preceding paragraph; and (b) govern all liabilities arising under the disclaimer, including liabilities arising in contract, in tort and for breach of statutory duty.
            </p>

            <p className="text-gray-600 leading-relaxed mb-6">
              As long as the website and the information and services on the website are provided free of charge, we will not be liable for any loss or damage of any nature.
            </p>

            <h2 className="text-3xl font-serif font-light text-sage-800 mt-12 mb-6">10. Governing Law & Jurisdiction</h2>
            <p className="text-gray-600 leading-relaxed mb-6">
              These terms and conditions will be governed by and construed in accordance with the laws of the State of California, and any disputes relating to these terms and conditions will be subject to the exclusive jurisdiction of the courts of California.
            </p>

            <h2 className="text-3xl font-serif font-light text-sage-800 mt-12 mb-6">Contact Information</h2>
            <p className="text-gray-600 leading-relaxed mb-6">
              If you have any queries regarding any of our terms, please contact us through our <Link to="/#booking" className="text-sage-600 hover:text-sage-700 underline">contact form</Link>.
            </p>

            <div className="bg-sage-50 p-6 rounded-xl mt-12">
              <p className="text-sm text-gray-600">
                <strong>Note:</strong> This document is provided for informational purposes. While we strive to keep this information accurate and up to date, we recommend consulting with a legal professional for specific legal advice regarding your use of our services.
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default TermsConditions;
